const requestListPaths = new Set([
  '/',
  '/dashboard',
  '/requests',
  '/requests/inspections',
  '/requests/reports',
  '/requests/billing',
  '/orders',
  '/claims',
  '/returns',
]);

const validReturnLocation = (value: unknown): value is string => {
  if (typeof value !== 'string' || /[\\\r\n]/.test(value)) return false;
  return requestListPaths.has(value.split(/[?#]/)[0]);
};

export const getRequestReturnTo = (
  search: string,
  stateReturnLocation: unknown,
  fallback: string,
): string => {
  const returnTo = new URLSearchParams(search).get('returnTo');
  if (validReturnLocation(returnTo)) return returnTo;
  if (validReturnLocation(stateReturnLocation)) return stateReturnLocation;
  return fallback;
};

export const withRequestReturnTo = (path: string, returnTo: string): string => {
  if (!validReturnLocation(returnTo)) return path;
  const [pathname, search = ''] = path.split('?');
  const params = new URLSearchParams(search);
  params.set('returnTo', returnTo);
  return `${pathname}?${params.toString()}`;
};

export const getShopifyOrderAdminUrl = (
  domain?: string | null,
  externalOrderId?: string | null,
): string | null => {
  const orderId = externalOrderId?.replace(/^gid:\/\/shopify\/Order\//, '');
  if (!domain || !orderId || !/^\d+$/.test(orderId)) return null;
  return `https://${domain}/admin/orders/${orderId}`;
};
